var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useState } from 'react';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import defaultAvatarImg from '../../../assets/img/default-avatar.png';
import { Menu, MenuDropdown } from '../../Menu';
import { Image } from '../../Image';
import { ContactForm } from '../../forms';
import { Flex } from '../../../layout';
import { ButtonSlim, ButtonLink } from '../../buttons';
import { Title, PictureWrapper, InfoBlock, InfoBlockTitle, InfoBlockItem, } from './styledComponents';
export var RepresentativeSimpleMenu = function (_a) {
    var _b = _a.isOpen, isOpen = _b === void 0 ? false : _b, _c = _a.title, title = _c === void 0 ? 'Customer Operations' : _c, _d = _a.infoBlockTitle, infoBlockTitle = _d === void 0 ? 'Customer Operations' : _d, subjectOptions = _a.subjectOptions, _e = _a.customerOpsEmail, customerOpsEmail = _e === void 0 ? '' : _e, _f = _a.imgSource, imgSource = _f === void 0 ? '' : _f, onMessageSubmit = _a.onMessageSubmit, onClose = _a.onClose, menuProps = __rest(_a, ["isOpen", "title", "infoBlockTitle", "subjectOptions", "customerOpsEmail", "imgSource", "onMessageSubmit", "onClose"]);
    var _g = useState(false), isContactFormOpen = _g[0], setIsContactFormOpen = _g[1];
    var closeDropdown = function () {
        setIsContactFormOpen(false);
        onClose();
    };
    var renderImage = function () { return (<Image src={imgSource || defaultAvatarImg} fallbackSrc={defaultAvatarImg} alt={title}/>); };
    var renderInfoBlock = function () {
        return (<InfoBlock data-testid="info-block">
        <PictureWrapper>{renderImage()}</PictureWrapper>
        <div>
          <InfoBlockTitle>{infoBlockTitle}</InfoBlockTitle>
          <InfoBlockItem>
            <AlternateEmailIcon />
            <a href={"mailto:".concat(customerOpsEmail)}>{customerOpsEmail}</a>
          </InfoBlockItem>
          <div style={{ marginTop: '2rem' }}>
            <ButtonSlim data-testid="contact-btn" onClick={function () { return setIsContactFormOpen(true); }}>
              Contact
            </ButtonSlim>
            <ButtonLink data-testid="cancel-btn" onClick={closeDropdown}>
              Cancel
            </ButtonLink>
          </div>
        </div>
      </InfoBlock>);
    };
    return (<Menu isOpen={isOpen} onClickOutside={closeDropdown} disableFocusRipple {...menuProps}>
      <Flex>
        <PictureWrapper>{renderImage()}</PictureWrapper>
        <Title>{title}</Title>
        <MenuDropdown position="left" isOpen={isOpen}>
          {isContactFormOpen ? (<ContactForm subjectOptions={subjectOptions} onSubmit={function () { return onMessageSubmit(); }} onClose={closeDropdown}/>) : (renderInfoBlock())}
        </MenuDropdown>
      </Flex>
    </Menu>);
};
